export default __webpack_public_path__ + "static/media/TheWorldBrazil_03.a6b11356.png";